import { createContext, useContext } from 'react';

export interface Theme {
  name: string;
  label: string;
  emoji: string;
}

export const themes: Theme[] = [
  { name: 'beige', label: 'Beige', emoji: '\ud83c\udf3e' },
  { name: 'midnight', label: 'Midnight', emoji: '\ud83c\udf19' },
  { name: 'forest', label: 'Forest', emoji: '\ud83c\udf32' },
  { name: 'clean', label: 'Clean', emoji: '\u2600\ufe0f' },
  { name: 'neon', label: 'Neon', emoji: '\u26a1' },
];

export function defaultTheme(): Theme {
  const [first] = themes;
  if (!first) throw new Error('themes array must not be empty');
  return first;
}

export interface ThemeContextValue {
  current: Theme;
  setTheme: (name: string) => void;
  next: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
